import React from 'react';
import PropTypes from 'prop-types';
import Highlighter from 'react-highlight-words';

import { Avatar, Text } from 'components/common/Elements/Elements';

import notVerified from 'assets/svg/notVerified.svg';

import classes from './Member.module.scss';

const Member = ({ member, searchText }) => {
  const {
    fullName,
    description,
    initials,
    initialsColor,
    emailVerified = true,
    icon
  } = member;

  return (
    <div className={classes.box}>
      {emailVerified ? (
        <>
          <Avatar
            className={classes.avatar}
            initials={initials}
            initialsColor={initialsColor}
            image={icon}
          />
          <div>
            <Text className={classes.name} weight="b">
              {!searchText ? (
                fullName
              ) : (
                <Highlighter
                  autoEscape
                  highlightClassName={classes.highlight}
                  searchWords={[searchText]}
                  textToHighlight={fullName}
                />
              )}
            </Text>
            <Text className={classes.description} size={2}>
              {!searchText ? (
                description
              ) : (
                <Highlighter
                  autoEscape
                  highlightClassName={classes.highlight}
                  searchWords={[searchText]}
                  textToHighlight={description}
                />
              )}
            </Text>
          </div>
        </>
      ) : (
        <>
          <div className={classes.noAvatar}>
            <img
              className={classes.noAvatar_icon}
              src={notVerified}
              width="16"
              height="16"
              alt=""
            />
          </div>
          <Text className={classes.email} weight="b">
            {description}
          </Text>
        </>
      )}
    </div>
  );
};

Member.propTypes = {
  member: PropTypes.object,
  searchText: PropTypes.string
};

export default Member;
